// The muscles a face chart mark can be labelled with, and what each is called.
// Kept apart from `face-muscles.ts` so screens that only need the names (the
// dose form, settings) do not pull in the face detector.
//
// The keys and the wording mirror `decoda/services/dose/face_chart_muscles.py`.

export const MUSCLE_KEYS = [
  "glabella",
  "frontalis",
  "orbicularis_oculi",
  "brow_lift",
  "nasalis",
  "orbicularis_oris",
  "dao",
  "mentalis",
  "masseter",
  "platysma",
] as const;

export type MuscleKey = (typeof MUSCLE_KEYS)[number];

export const MUSCLE_LABELS: Record<MuscleKey, string> = {
  glabella: "Glabella",
  frontalis: "Frontalis",
  orbicularis_oculi: "Orbicularis oculi",
  brow_lift: "Eyebrow lift",
  nasalis: "Nasalis",
  orbicularis_oris: "Orbicularis oris",
  dao: "DAO",
  mentalis: "Mentalis",
  masseter: "Masseter",
  platysma: "Platysma",
};

/** The names to show for each muscle: the clinic's own where it has renamed
 *  one, the default otherwise. Blank or unknown entries are ignored, matching
 *  `custom_labels` on the server. */
export function muscleNames(
  renamed: { muscle: string; label: string }[] | null | undefined,
): Record<MuscleKey, string> {
  const names = { ...MUSCLE_LABELS };
  for (const entry of renamed ?? []) {
    const label = typeof entry?.label === "string" ? entry.label.trim() : "";
    if (isMuscleKey(entry?.muscle) && label) names[entry.muscle] = label;
  }
  return names;
}

export function isMuscleKey(value: unknown): value is MuscleKey {
  return (
    typeof value === "string" &&
    (MUSCLE_KEYS as readonly string[]).includes(value)
  );
}
